import React from 'react'
import Svg from './Svg'
export const SvgInvestigations = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 0h3v24H0V0zM19.5 15.071c1.937 0 3.623-.469 4.5-1.161v-12c-.877.692-2.563 1.161-4.5 1.161-1.937 0-3.622-.469-4.5-1.161v12c.878.692 2.563 1.161 4.5 1.161zM14.25.762C13.151.295 11.543 0 9.75 0 7.491 0 5.524.469 4.5 1.16v12C5.524 12.469 7.491 12 9.75 12c1.793 0 3.401.295 4.5.762v-12z" />
  </Svg>
))
SvgInvestigations.isIcon = true
export default SvgInvestigations
